module.exports = __webpack_public_path__ + "static/media/get_token.05c646ac.mp3";